import countryData from "country-telephone-data";

const DEFAULT_COUNTRY_CODE = "+91";
const E164_MAX_DIGITS = 15;
const COUNTRY_PHONE_LIMIT_OVERRIDES = {
  977: 10,
};

// Normalize country code (remove +, spaces, etc.)
const normalizeCountryCode = (countryCode = DEFAULT_COUNTRY_CODE) =>
  String(countryCode || DEFAULT_COUNTRY_CODE).replace(/\D/g, "");

// Get max local phone number length for selected country
export const getPhoneNumberLimit = (countryCode = DEFAULT_COUNTRY_CODE) => {
  const dialCode = normalizeCountryCode(countryCode);

  if (COUNTRY_PHONE_LIMIT_OVERRIDES[dialCode]) {
    return COUNTRY_PHONE_LIMIT_OVERRIDES[dialCode];
  }

  const country = countryData.allCountries.find(
    (item) => item.dialCode === dialCode,
  );

  if (country?.format) {
    const digitCount = (country.format.match(/\./g) || []).length;

    if (digitCount > dialCode.length) {
      return Math.min(
        digitCount - dialCode.length,
        E164_MAX_DIGITS - dialCode.length,
      );
    }
  }

  return E164_MAX_DIGITS - dialCode.length;
};

// Sanitize phone number
export const sanitizePhoneNumber = (
  value,
  countryCode = DEFAULT_COUNTRY_CODE,
) => {
  if (!value) return "";

  let digits = String(value).replace(/\D/g, "");
  const dialCode = normalizeCountryCode(countryCode);
  const phoneLimit = getPhoneNumberLimit(countryCode);

  // Handle 00 prefix (e.g. 0091xxxxxxxxxx)
  if (digits.startsWith(`00${dialCode}`) && digits.length > phoneLimit) {
    digits = digits.slice(dialCode.length + 2);
  }

  // Remove country code only if it's an extra prefix
  else if (digits.startsWith(dialCode) && digits.length > phoneLimit) {
    digits = digits.slice(dialCode.length);
  }

  // Trim to max allowed local length
  return digits.slice(0, phoneLimit);
};

// Validate exact local number length
export const isValidPhoneNumberForCountry = (
  value,
  countryCode = DEFAULT_COUNTRY_CODE,
) =>
  sanitizePhoneNumber(value, countryCode).length ===
  getPhoneNumberLimit(countryCode);

// Validation message
export const getPhoneNumberLimitMessage = (
  countryCode = DEFAULT_COUNTRY_CODE,
) => `Phone number must be ${getPhoneNumberLimit(countryCode)} digits`;
